<template>
  <div class="container-html">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div style="width: 100%; margin-top: 10px">
      <AgeRange label="0 à 18 anos" :value="age_0_18" v-model="age_0_18" :chatbotColors="chatbotColors" :lastMessage="lastMessage" white />
      <AgeRange label="19 à 23 anos" :value="age_19_23" v-model="age_19_23" :chatbotColors="chatbotColors" :lastMessage="lastMessage" />
      <AgeRange label="24 à 28 anos" :value="age_24_28" v-model="age_24_28" :chatbotColors="chatbotColors" :lastMessage="lastMessage" white />
      <AgeRange label="29 à 33 anos" :value="age_29_33" v-model="age_29_33" :chatbotColors="chatbotColors" :lastMessage="lastMessage" />
      <AgeRange label="34 à 38 anos" :value="age_34_38" v-model="age_34_38" :chatbotColors="chatbotColors" :lastMessage="lastMessage" white />
      <AgeRange label="39 à 43 anos" :value="age_39_43" v-model="age_39_43" :chatbotColors="chatbotColors" :lastMessage="lastMessage" />
      <AgeRange label="44 à 48 anos" :value="age_44_48" v-model="age_44_48" :chatbotColors="chatbotColors" :lastMessage="lastMessage" white />
      <AgeRange label="49 à 53 anos" :value="age_49_53" v-model="age_49_53" :chatbotColors="chatbotColors" :lastMessage="lastMessage" />
      <AgeRange label="54 à 58 anos" :value="age_54_58" v-model="age_54_58" :chatbotColors="chatbotColors" :lastMessage="lastMessage" white />
      <AgeRange label="59 anos ou mais" :value="age_59" v-model="age_59" :chatbotColors="chatbotColors" :lastMessage="lastMessage" />
    </div>
    <div class="options-container">
      <button type="button" class="botao" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }" @click.prevent="addAgeRanges" :disabled="lastMessage === false || anyAge === false">CONTINUAR</button>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from "./../store/"
import AgeRange from '../components/hapvida-rv/AgeRange.vue'

export default {
  components: {
    AgeRange
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      age_0_18: 0,
      age_19_23: 0,
      age_24_28: 0,
      age_29_33: 0,
      age_34_38: 0,
      age_39_43: 0,
      age_44_48: 0,
      age_49_53: 0,
      age_54_58: 0,
      age_59: 0,
    }
  },
  computed: {
    anyAge () {
      return (
        this.age_0_18
        + this.age_19_23
        + this.age_24_28
        + this.age_29_33
        + this.age_34_38
        + this.age_39_43
        + this.age_44_48
        + this.age_49_53
        + this.age_54_58
        + this.age_59
      ) >= (this.message.data.metadata?.minimo_vidas || 1);
    },
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    },
    me(){
      return this.message.author === 'me';
    }
  },
  methods: {
    addAgeRanges () {
      const text = [];
      const options = {};

      if (this.age_0_18 > 0) {
        text.push(`0 à 18 anos = ${this.age_0_18} ${this.age_0_18 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_0_18 = this.age_0_18;
      }

      if (this.age_19_23 > 0) {
        text.push(`19 à 23 anos = ${this.age_19_23} ${this.age_19_23 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_19_23 = this.age_19_23;
      }

      if (this.age_24_28 > 0) {
        text.push(`24 à 28 anos = ${this.age_24_28} ${this.age_24_28 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_24_28 = this.age_24_28;
      }

      if (this.age_29_33 > 0) {
        text.push(`29 à 33 anos = ${this.age_29_33} ${this.age_29_33 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_29_33 = this.age_29_33;
      }

      if (this.age_34_38 > 0) {
        text.push(`34 à 38 anos = ${this.age_34_38} ${this.age_34_38 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_34_38 = this.age_34_38;
      }

      if (this.age_39_43 > 0) {
        text.push(`39 à 43 anos = ${this.age_39_43} ${this.age_39_43 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_39_43 = this.age_39_43;
      }

      if (this.age_44_48 > 0) {
        text.push(`44 à 48 anos = ${this.age_44_48} ${this.age_44_48 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_44_48 = this.age_44_48;
      }

      if (this.age_49_53 > 0) {
        text.push(`49 à 53 anos = ${this.age_49_53} ${this.age_49_53 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_49_53 = this.age_49_53;
      }

      if (this.age_54_58 > 0) {
        text.push(`54 à 58 anos = ${this.age_54_58} ${this.age_54_58 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_54_58 = this.age_54_58;
      }

      if (this.age_59 > 0) {
        text.push(`59 anos ou mais = ${this.age_59} ${this.age_59 === 1 ? 'pessoa' : 'pessoas'}`);
        options.age_59 = this.age_59;
      }

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text: text.join('<br>'), metadata: options }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-message--text {
  margin-right: 0 !important;
}
.sc-message--text-content {
  -webkit-perspective: 0px !important;
  -webkit-backface-visibility: visible !important;
  -webkit-transform: translate3d(0,0,0) !important;
}
a.chatLink {
  color: inherit !important;
}
.options-container {
  margin-top: 10px;

  .botao {
    display: inline-block;
    margin: 0 5px 5px 0;
    padding: 10px 15px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }
    &:disabled {
      opacity: .3;
      cursor: not-allowed;
    }
  }
}
</style>
